import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import { ODOMETER_BY_VEHICLE_UPDATED } from '../query/trackable'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
// import absintheSocketLink from '../graphql/AbsintheSocketLink'
import omegaAbsintheSocketLink from '../graphql/OmegaAbsintheSocketLink'
import currencyFormatter from 'currency-formatter'
import config from '../config'
import { HttpLink } from 'apollo-link-http'
import { getMainDefinition } from 'apollo-utilities'
import { setContext } from 'apollo-link-context'

const httpLink = new HttpLink({
  uri: config.omega_graphql_api
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  omegaAbsintheSocketLink,
  authLink.concat(httpLink)
)

const omegaClient = new ApolloClient({
  link,
  cache: new InMemoryCache()
})

class OdometerComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      trackableStatus: this.props.trackableStatus
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update state when trackableStatus prop changes (from polling)
    if (nextProps.trackableStatus !== this.props.trackableStatus) {
      this.setState({
        trackableStatus: nextProps.trackableStatus
      })
    }
  }

  // componentDidMount () {
  //   this.props.subscribeToMore({
  //     document: ODOMETER_BY_VEHICLE_UPDATED,
  //     variables: { id: this.props.trackableId },
  //     client: { omegaClient },
  //     updateQuery: (prev, {
  //       subscriptionData
  //     }) => {
  //       if (!subscriptionData.data) {
  //         return prev
  //       } else {
  //         this.setState({
  //           trackableStatus: subscriptionData.data.trackable_status_update
  //         })
  //         return {
  //           trackableStatus: subscriptionData.data.trackable_status_update
  //         }
  //       }
  //     }
  //   })
  // }

  render () {
    const self = this
    let trackableStatus = self.state.trackableStatus
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='ODOMETRE'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <span style={styles.number}>{currencyFormatter.format(trackableStatus.metadata.odometer / 1000, {
              symbol: '',
              decimal: ',',
              thousand: ' ',
              precision: 1,
              format: '%v %s'
            })}<br /> <span style={styles.unit}>Km</span></span>
            {/* <span style={styles.number}>{currencyFormatter.format(trackableStatus.metadata.odometer, {
              symbol: '',
              decimal: '.',
              thousand: ',',
              precision: 1,
              format: '%v %s'
            })}<br /> <span style={styles.unit}>Km</span></span> */}
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '98px'
  },
  number: {
    fontSize: '42px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  unit: {
    fontSize: '14px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  }
}

export default OdometerComponent
